import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import {
  AutoSizer,
  List,
  InfiniteLoader,
  CellMeasurerCache,
} from 'react-virtualized'
import classNames from 'classnames'

import { providesUserPreferencesMutations } from 'components/Settings/User/dataSync'
import { selectors as NoteActivitiesSelectors } from 'data/noteActivities'
import { trackNavigateToActivity } from 'data/analytics/actions'
import { fetchesNoteActivities } from '../dataSync'
import Row from '../Row'
import ListPlaceholder from './Placeholder'

class ActivityList extends Component {
  constructor(props, context) {
    super(props, context)
    this.cache = new CellMeasurerCache({
      defaultHeight: 240,
      fixedWidth: true,
    })
  }

  componentDidMount() {
    this.props.fetchNextPage({ startFresh: true })
    this.props.trackNavigateToActivity()
    this.props.updateUserPreferences({
      lastActivityFeedViewedAt: new Date().toISOString(),
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.items.length > this.props.items.length) {
      this.cache.clearAll()
    }
  }

  render() {
    const { listState, items } = this.props

    const isEmpty = listState.totalCount === 0
    const isLoaded = listState.totalCount != null && !isEmpty

    return (
      <div
        className={classNames('width-full height-full', 'padding-bottom-huge')}
      >
        {isEmpty && <ListPlaceholder />}
        {isLoaded && (
          <InfiniteLoader
            isRowLoaded={this.isRowLoaded}
            loadMoreRows={listState.loading ? () => {} : this.loadMoreRows}
            rowCount={listState.totalCount}
            threshold={30}
          >
            {({ onRowsRendered, registerChild }) => (
              <AutoSizer>
                {({ width, height }) => (
                  <List
                    className="no-outline"
                    style={{ paddingBottom: 300 }}
                    deferredMeasurementCache={this.cache}
                    onRowsRendered={onRowsRendered}
                    ref={registerChild}
                    height={height}
                    width={width}
                    rowCount={items.length}
                    rowRenderer={this.rowRenderer}
                    rowHeight={this.cache.rowHeight}
                    overscanRowCount={0}
                  />
                )}
              </AutoSizer>
            )}
          </InfiniteLoader>
        )}
      </div>
    )
  }

  rowRenderer = ({ index, key, style, parent }) => {
    const { items } = this.props
    return (
      <Row
        cache={this.cache}
        parent={parent}
        key={key}
        style={style}
        index={index}
        item={items[index]}
        previousItem={items[index - 1]}
      />
    )
  }

  isRowLoaded = ({ index }) => {
    return index < this.props.items.length
  }

  loadMoreRows = () => {
    const { fetchNextPage, listState } = this.props
    if (!listState.pageInfo.hasNextPage || listState.loading) {
      return
    }
    fetchNextPage()
  }
}

function mapStateToProps(state) {
  const noteActivitiesIds = NoteActivitiesSelectors.getAllNoteActivitiesIds(
    state
  )
  let previousNoteActivity = null
  const items = noteActivitiesIds.reduce((memo, noteActivityId) => {
    const noteActivity = NoteActivitiesSelectors.getNoteActivity(
      state,
      noteActivityId
    )
    const sameNote =
      previousNoteActivity &&
      previousNoteActivity.get('noteId') === noteActivity.get('noteId')
    previousNoteActivity = noteActivity
    return sameNote
      ? memo.slice(0, -1).concat([memo[memo.length - 1].concat(noteActivity)])
      : memo.concat([[noteActivity]])
  }, [])

  return {
    noteActivitiesIds: NoteActivitiesSelectors.getAllNoteActivitiesIds(state),
    listState: NoteActivitiesSelectors.getAllNoteActivitiesListState(state),
    items,
  }
}

export default compose(
  providesUserPreferencesMutations,
  fetchesNoteActivities(), // provides fetchNextPage prop + auto fetch on mount
  connect(
    mapStateToProps,
    { trackNavigateToActivity }
  )
)(ActivityList)
